<template>
  <v-stepper v-model="step" class="stepper-container">
    <v-stepper-header>
      <template v-for="stepper in steppers">
        <v-stepper-step
          :key="stepper.step"
          class="stepper-item"
          :class="{ 'step-blocked': !stepper.complete && stepper.step !== step }"
          :complete="stepper.complete"
          :step="stepper.step"
        >
          {{ stepper.stepName }}
        </v-stepper-step>

        <v-divider v-if="stepper.step !== steppers.length" :key="`divider-${stepper.step}`" />
      </template>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
export default {
  name: 'Stepper',

  props: {
    step: {
      type: Number,
      default: () => 1,
      validator: (step) => step > 0 && step < 6,
    },
    steppers: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.stepper-container {
  background: transparent;
  border: none;
  box-shadow: none;
  padding: 0;
}

.stepper-item:first-of-type {
  padding-left: 0;
}

.stepper-item:last-of-type {
  padding-right: 0;
}

::v-deep .v-stepper__step__step {
  background-color: $branco !important;
  color: #a5acb4 !important;
  border: 2px solid#A5ACB4 !important;
  height: 30px !important;
  width: 30px !important;
}

::v-deep .v-stepper__step__step.primary,
::v-deep .v-stepper__step__step.primary > i {
  border-color: #33be81 #26a77e #26a379 #37cb88 !important;
  color: #37cb88 !important;
  font-weight: bold;
}

::v-deep .v-stepper__step__step.primary + div {
  color: $marca-1-d30 !important;
}

::v-deep .v-stepper__step--complete > .v-stepper__step__step.primary {
  background-color: $marca-1-d30 !important;
  border-color: $marca-1-d30 !important;

  i {
    color: $branco !important;
  }
}
</style>
